<template>
  <div>
    <Info :userInfo="userInfo" />
    <el-tabs v-model="currentValue" class="tabs-list">
      <el-tab-pane
        v-for="(o, oIndex) in tabList"
        :key="oIndex"
        :label="o.label"
        :name="o.name"
        class="tabs-content"
        v-loading="tableLoading"
      >
        <Table
          :obj="o.data"
          @sizeChange="sizeChange"
          @pageChange="pageChange"
        />
      </el-tab-pane>
    </el-tabs>
    <DialogList
      :dialogVisible="dialogTableVisibleNew"
      @closeDialog="closeConstDetailPop"
    />
    <Accountdialog
      :dialogVisible="accountDialogTableVisible"
      @closeDialog="closeAccountDetailPop"
    />
  </div>
</template>

<script>
import Info from "./module/info.vue";
import { getSessionUser, inviteFriends, inviteRecords } from "@/api/auth";
import Table from "./module/table.vue";
import DialogList from "../materialDownload/module/dialog.vue";
import Accountdialog from "../materialDownload/module/accountdialog";

export default {
  name: "PersonalCenter",
  components: {
    Info,
    Table,
    DialogList,
    Accountdialog,
  },
  data() {
    return {
      userInfo: {
        balance: 0.0,
        invitePrices: 0,
        inviteCode: "",
        email: "",
        phone: "",
        faiUuid: 0,
      },
      currentValue: "first",
      tabList: [
        {
          label: "Invitation",
          name: "first",
          data: {},
        },
      ],
      tableLoading: false,
      pageNo: 1,
      pageSize: 10,
      dialogTableVisibleNew: false,
      accountDialogTableVisible: false,
    };
  },
  mounted() {
    this.$EventBus.$on("constDetailOut", this.openConstDetailPop);
    this.$EventBus.$on("accountDetailOut", this.openAccountDetailPop);
    this.getUserList();
    this.invateFriend();
    this.initGoogleAnalytics();
  },
  beforeDestroy() {
    this.$EventBus.$off("constDetailOut", this.openConstDetailPop);
    this.$EventBus.$off("accountDetailOut", this.openAccountDetailPop);
  },
  methods: {
    // 初始化 Google Analytics
    initGoogleAnalytics() {
      window.dataLayer = window.dataLayer || [];
      const gtag = (...args) => dataLayer.push(args);
      gtag("js", new Date());
      gtag("config", "UA-78962210-9");
    },

    // 获取邀请好友信息
    async invateFriend() {
      try {
        const result = await inviteFriends();
        const fullPath = window.location.href;
        const oLastPath = this.$route.path;
        const nLastPath = `/registered?faiUuid=${result}`;
        const link = fullPath.replace(oLastPath, nLastPath);
        const host = fullPath.replace(oLastPath, "");

        // 存储邀请信息到 store，而不是直接操作 DOM
        this.$store.commit("SET_INVITE_INFO", {
          link,
          host,
          code: result,
          message: `You are invited to join:${link} Shutterstock, AdobeStock, iStockphoto, 123RF, Dreamstime, etc., high-quality vectors worldwide are all in GetStock.cc, register and remember to fill in the invitation code:${result}`,
        });

        this.userInfo.inviteCode = result;
      } catch (error) {
        console.error("Invite friend error:", error);
      }
    },

    // 获取用户信息
    async getUserList() {
      try {
        const result = await getSessionUser();
        if (result) {
          this.$store.dispatch("setUserInfo", result);
          this.userInfo.balance = result.blance;
          this.userInfo.email = result.mail;
          this.userInfo.phone = result.mobile;
          this.userInfo.invitePrices = result.blanceInviteAdd;
          this.userInfo.faiUuid = result.faiUuid;
          this.getTableDatas();
        }
      } catch (error) {
        console.error("Get user list error:", error);
      }
    },

    // 获取表格数据
    async getTableDatas() {
      this.tableLoading = true;
      try {
        const dataform = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          faiUuid: this.userInfo.faiUuid,
        };
        const result = await inviteRecords(dataform);
        this.tabList.forEach((item) => {
          item.data = result;
        });
      } catch (error) {
        console.error("Get table data error:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 前往支付页面
    goPayments() {
      this.$store.dispatch("setBalanceIndex", 1);
      this.goBalancePage();
    },

    // 前往订单页面
    goOrder() {
      this.$store.dispatch("setBalanceIndex", 0);
      this.goBalancePage();
    },

    goBalancePage() {
      this.$router.push({
        path: "/balance",
      });
    },

    // 分页变化
    pageChange(params) {
      this.pageNo = params;
      this.pageSize = 10;
      this.getTableDatas();
    },

    // 每页条数变化
    sizeChange(param) {
      this.pageSize = param;
      this.pageNo = 1;
      this.getTableDatas();
    },

    // 费用明细
    openConstDetailPop() {
      this.dialogTableVisibleNew = true;
    },

    closeConstDetailPop() {
      this.dialogTableVisibleNew = false;
    },

    // 余额明细
    openAccountDetailPop() {
      this.accountDialogTableVisible = true;
    },

    closeAccountDetailPop() {
      this.accountDialogTableVisible = false;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.normalText {
  font-size: 12px !important;
  color: #4a4a4a !important;
}

.findPasswordText {
  color: #007ddb !important;
}

.compatible-wrap {
  width: 640px;
  height: 370px;
  background-color: #fff;
  padding: 58px;
  display: flex;
}

.compatible-wrap__img {
  width: 115px;
  height: 100px;
  background-image: url("https://pub-cdn-oss.chuangkit.com/sys/front/compatible.svg");
}

.compatible-wrap__title {
  color: #6b6b6b;
  font-size: 18px;
  margin-left: 20px;
  line-height: 1.6;
}

.compatible-wrap__p {
  color: #6b6b6b;
  font-size: 14px;
  margin-left: 20px;
  margin-top: 24px;
}

.compatible-wrap__button {
  width: 174px;
  height: 40px;
  margin-left: 20px;
  background-color: #0773fc;
  line-height: 40px;
  border-radius: 3px;
  color: #fff;
  margin-top: 40px;
  outline: none;
  border: none;
  display: inline-block;
  text-align: center;

  &:hover {
    opacity: 0.6;
    cursor: pointer;
    color: #fff;
  }
}

#compatible-wrap {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999999;
  top: 0;
  left: 0;
}

.compatible-wrap__mask {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}

.compatible-wrap__wrap {
  width: 640px;
  height: 370px;
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.div_border {
  padding: 10px;
  background: #eaeaea;
  border-radius: 10px;
  text-align: center;
}

.invite_border {
  margin-left: 20px;
  margin-right: 20px;
  padding: 10px;
  background: #fdfdfd;
  border-radius: 2px;
  text-align: center;
}

.copy_button {
  color: #4a4a4a;
  margin-top: 2px;
  margin-left: 20px;
  padding: 5px 10px;
  background-color: #ffffff;
  text-align: center;
  border: 1px solid gray;
  border-radius: 20px;
  cursor: pointer;
  font-size: 12px;
  width: 80px;
}

.invite_text {
  border: 2px solid #fbfbfb;
  border-radius: 20px;
  background-color: #fbfbfb;
  float: left;
  margin-left: 20px;
  min-height: 35px;
  text-align: center;
  font-size: 12px;

  span {
    padding: 5px;
  }
}

.invite_dec {
  margin-right: 20px;
  margin-top: 20px;
  text-align: left;
  font-size: 12px;
  border-radius: 2px;

  p {
    padding: 5px;
  }
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.head_right_item {
  font-size: 16px;
  padding: 5px;
}
</style>
